module.exports = require("babel-runtime/core-js/number/is-safe-integer");